import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { map } from 'lodash';
import i18next from 'i18next';
import { AppManagementDto } from '../../../../../shared/dtos/appManagement.dto';
import { useAuthFetchFromRestAPI } from '../../../util/api';
import PrimaryButton from '../../../components/PrimaryButton';
import AppModal from '../../../components/app-modal/AppModal';
import AppManagementModal from './AppManagementModal';

const AppManagement = (): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [versionList, setVersionList] = useState<AppManagementDto[]>([]);
  const { authFetch } = useAuthFetchFromRestAPI();

  const fetchVersions: () => Promise<void> = useCallback(async () => {
    setVersionList([]);
    setIsLoading(true);

    const versions: AppManagementDto[] = await authFetch('/api/v1/admin/version', { method: 'GET' });

    if (versions && versions.length > 0) {
      setVersionList(versions);
    }

    setIsLoading(false);
  }, [authFetch]);


  useEffect(() => {
    void fetchVersions();
  }, []);

  return (
    <React.Fragment>
      <div className="d-flex justify-content-end my-3">
        <PrimaryButton className="ms-2" onClick={() => setShowCreateModal(!showCreateModal)} disabled={isLoading}>
          {i18next.t('generic.create')}
        </PrimaryButton>
        <PrimaryButton className="ms-2" onClick={() => fetchVersions()} disabled={isLoading}>
          {i18next.t(isLoading ? 'appManagement.buttons.refreshing' : 'appManagement.buttons.refresh')}
        </PrimaryButton>
      </div>

      <Table striped bordered hover responsive={true} className="h-75 overflow-auto">
        <thead>
          <tr>
            <th className='centered-td'>{i18next.t('appManagement.table.update')}</th>
            <th className='centered-td'>{i18next.t('appManagement.table.bottomPanel')}</th>
            <th className='centered-td'>{i18next.t('appManagement.table.featureList')}</th>
          </tr>
        </thead>
        <tbody key={versionList.length}>
          {map(versionList, (version: AppManagementDto) => {
            return (
              <tr key={version._id}>
                <td className='centered-td'>{version.updateReqVersion}</td>
                <td className='centered-td w-25'>
                  {version.loginBottomPanel?.replace(/\\n/g, '').replace(/\\/g, '') ?? ''}
                </td>
                <td className='centered-td'>{version.featureList}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <AppModal show={showCreateModal} dialogClassName="modal-dialog-centered" onHide={() => setShowCreateModal(false)}>
        <AppManagementModal onCreate={async () => {
          setShowCreateModal(false);
          await fetchVersions();
        }}/>
      </AppModal>
    </React.Fragment>
  );
};
export default AppManagement;
